import(/* webpackMode: "eager" */ "/app/apps/web/app/(app)/tournaments/[tournamentId]/scoring/error.tsx");
